import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { offerModels } from '..';

export function useRealtors(offerId?: number) {
  const visible = useAppSelector(({ offerReducer }) => offerReducer.createOrUpdate.visible);

  const initial = {
    realtors: []
  };

  const { data = initial, ...arg } = useQuery<{
    realtors: offerModels.RealtorType[];
  }>(
    ['offer-realtors', offerId],
    async () => {
      const { data } = offerId
        ? await $api.get(`/v1/company/offer-realtor?offerId=${offerId}`)
        : await $api.post('/v1/company/realtor/filter', { page: 1, size: 500 });

      return { realtors: offerId ? data?.data : data?.data?.data };
    },
    {
      enabled: visible
    }
  );

  return { ...data, ...arg };
}
